import React, { useState } from 'react';
import { humanize } from '../agentContextMap';
import { extractStats, extractTable, formatCell } from '../resultTable';

function ResultView({ result, tooLarge, maxRows = 8 }) {
  const [showAll, setShowAll] = useState(false);

  if (tooLarge) return <p className="dagent-muted">This result is large. Open the Ledger tab to inspect it.</p>;
  if (result === undefined) return <p className="dagent-muted">Waiting for the result…</p>;

  const stats = extractStats(result);
  const table = extractTable(result);
  const rows = table ? (showAll ? table.rows : table.rows.slice(0, maxRows)) : [];

  return (
    <div className="dagent-result">
      {stats.length > 0 && (
        <div className="dagent-stats">
          {stats.map((stat) => (
            <div key={stat.label} className="dagent-stat">
              <span>{stat.label}</span>
              <strong>{stat.value}</strong>
            </div>
          ))}
        </div>
      )}

      {table && (
        <div className="dagent-table-wrap">
          <table className="dagent-table">
            <thead>
              <tr>
                {table.columns.map((column) => (
                  <th key={column}>{humanize(column)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  {table.columns.map((column) => (
                    <td key={column} className={row[column] === false ? 'is-false' : row[column] === true ? 'is-true' : ''}>
                      {formatCell(row[column], column)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {table.total > maxRows && (
            <button type="button" className="dagent-link-btn" onClick={() => setShowAll((value) => !value)}>
              {showAll ? 'Show fewer' : `Show all ${table.total} ${table.title.toLowerCase()}`}
            </button>
          )}
        </div>
      )}

      {!table && stats.length === 0 && <pre className="dagent-json">{JSON.stringify(result, null, 2).slice(0, 4000)}</pre>}

      <details className="dagent-raw">
        <summary>Raw result</summary>
        <pre>{JSON.stringify(result, null, 2).slice(0, 20000)}</pre>
      </details>
    </div>
  );
}

export default ResultView;
